import { GoabButton } from "@abgov/react-components"
import { createPageTestId, createButtonTestId } from "../../common/utils/testIds"

export const LoggedOut = () => {
  return (<>
    <div className="content" data-testid={createPageTestId('logged-out')}>
      <h1 data-testid={createPageTestId('logged-out-title')}>Logged Out</h1>
      <p data-testid={createPageTestId('logged-out-message')}>You have successfully logged out from the Wildfire Applications Portal</p>
      <GoabButton data-testid={createButtonTestId('login')} size='compact' onClick={() => window.location.href = window.location.origin}>Login</GoabButton>
    </div>
  </>)
}


